import { useMemo } from 'react'
import { useStoreActions, useStoreState } from '../../../../store/hooks'
import Character from '../../components/Character'

const PuzzlePracticeCharacter: React.FC = () => {
    const puzzle = useStoreState((state) => state.puzzlePracticeView.puzzle)
    const progressGameTree = useStoreState((state) => state.puzzlePracticeView.progressGameTree)
    const myColor = useStoreState((state) => state.puzzlePracticeView.myColor)
    const feedbackType = useStoreState((state) => state.puzzlePracticeView.feedbackType)
    const setFeedbackType = useStoreActions((state) => state.puzzlePracticeView.setFeedbackType)

    const positions = useMemo(
        () => progressGameTree.positions.filter((position) => position.position.turn === myColor),
        [progressGameTree.positions, myColor],
    )

    const clearFeedbackType = () => {
        setFeedbackType(undefined)
    }

    return (
        <Character
            avatar="/assets/images/characters/puzzle-character.webp"
            message={puzzle?.description || ''}
            myColor={myColor}
            movesCount={positions.length}
            feedbackType={feedbackType}
            clearFeedbackType={clearFeedbackType}
        />
    )
}

export default PuzzlePracticeCharacter
